<template>
  <div class="flex column" style="width: 100vm" v-title data-title="其他问题">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutStudentPass",
    data () {
      return{
        list: [
          {
            title: '闯关规则是什么？',
            detailTexts: [{img: require('../assets/pass_rule.png')}]
          },
          {
            title: '阅芽是什么？',
            detailTexts: [{title: '阅芽是阅伴App的积分，可累积可消耗，阅芽数量越多，说明孩子阅读越认真。'}]
          },
          {
            title: '如何获得阅芽',
            detailTexts: [{title: '闯关奖励：闯关成功后，会根据闯关用时、答对题数的不同奖励不同数量的阅芽，用时越短，答对题数越多，奖励的阅芽越多。'},
              {title: '注册赠送：注册成功即赠送50片阅芽。'},
              {title: '会员赠送：登录阅伴App，普通会员每天可获得10片阅芽。超级会员每天可获得20片阅芽。'},
              {title: '购书获得：在阅伴官方书店购书，确认收货24小时后兑换获得。兑换流程：请跳转至“阅伴App-我的-兑换阅芽”查看详细流程。'},
              {title: '阅芽农场获得：在阅芽农场通过种树、浇水等，可获得阅豆奖励，阅豆可以在农场商城中兑换阅芽。'}]
          },
          {
            title: '如何使用阅芽',
            detailTexts: [{title: '阅芽的使用与闯关答题息息相关，合理使用阅芽，对于同学们的阅读闯关会有很大的帮助，阅芽的消耗主要是以下几方面：\n' +
                '重复闯关：同学们在闯关答题过程中，如果闯关失败，再次进行闯关时，会每次扣除5片阅芽。（所以，请同学们一定要认真阅读后再去闯关哦）；'},{title: '解锁关卡：提前解锁其它关卡，解锁每一个关卡会消耗2片阅芽；\n' +
                '查看错题：闯关成功以后，想看看自己究竟出错在什么地方，可以消耗2片阅芽查看错题。'}]
          },
          {
            title: '金钥匙是什么？',
            detailTexts: [{title: '金钥匙可解锁某一关卡无需要阅芽且无限闯关权限。'}]
          },
          {
            title: '如何查看错题，为什么有的时候不能查看错题？',
            detailTexts: [{title: '答题完成，点击提交后，显示闯关成功但未获得满分时，有查看错题按钮，点击即可查看错题。'},
              {title: '如果此关卡闯关失败，则无法查看错题。'}]
          },
          {
            title: '题目未全部答完想要退出怎么办？',
            detailTexts: [{title: '题目未答完时退出，将以闯关失败记录成绩，下次再回闯本关时，会视为重复闯关。'}]
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutStudentPass.vue